import { Tag } from "antd";
import React, { Fragment, useEffect, useState } from "react";
import { Animated } from "react-animated-css";
import Typist from "react-typist";
import { Feed, Image } from "semantic-ui-react";
import mylogo from "../assets/logo.png";
/**
 * @author
 * @function Interview
 **/

const Interview = ({ value }) => {
  const [sequence, setSequence] = useState();
  const data = [
    {
      name: "!resume",
      text: "!resume",
      type: "text",
      image_url: mylogo,
      message: "question"
    },
    {
      name: "!resume",
      text: "click here to download me",
      type: "link",
      image_url: mylogo,
      message: "response"
    }
  ];

  const preload = gotValue => {
    if (gotValue === "!resume") {
      setSequence(data);
    }
  };

  useEffect(() => {
    if (value !== undefined) {
      preload(value);
    }
    // eslint-disable-next-line
  }, [value]);

  const MyMessage = seq => {
    return (
      <>
        <Animated
          animationIn="fadeIn"
          animationOut="fadeOut"
          isVisible={true}
          animationInDelay={seq.message === "response" ? 2000 : 0}
        >
          <div
            style={{
              float: "left",
              display: "block",
              width: "100%",
              padding: "7px",
              marginBottom: "5px"
            }}
          >
            <Feed
              style={{ float: seq.message === "response" ? "left" : "right" }}
            >
              <Feed.Event>
                <Feed.Label>
                  <Image
                    floated={seq.message === "response" ? "left" : "right"}
                    alt="A"
                    src={seq.image_url}
                  />
                </Feed.Label>

                <Feed.Content>
                  <Tag color="success">
                    <Typist cursor={{ show: false }}>
                      <Typist.Delay ms={2000} />
                      <p style={{ color: "green" }}>
                        {seq.type === "link" ? (
                          <a href="Ahmer Aftab Patel.pdf">{seq.text}</a>
                        ) : (
                          seq.text
                        )}
                      </p>
                    </Typist>
                  </Tag>
                </Feed.Content>
              </Feed.Event>
            </Feed>
          </div>
        </Animated>
      </>
    );
  };

  const errorMessage = (
    <Tag style={{ textAlign: "center" }} closable={true} color="red">
      Command not found
    </Tag>
  );
  const TheirMessage = seq => {
    return (
      <>
        <Animated
          animationIn="fadeIn"
          animationOut="fadeOut"
          isVisible={true}
          animationInDelay={seq.message === "response" ? 2000 : 0}
        >
          <div
            style={{
              float: "left",
              display: "block",
              width: "100%",
              padding: "7px",
              marginBottom: "5px"
            }}
          >
            <Feed
              style={{ float: seq.message === "response" ? "left" : "right" }}
            >
              <Feed.Event>
                <Feed.Content>
                  <Tag color="green">
                    {/* <p style={{marginTop : "6px",marginRight : "10px" }}> */}
                    {seq.type === "link" ? (
                      <a href="Ahmer Aftab Patel.pdf">{seq.text}</a>
                    ) : (
                      seq.text
                    )}
                    {/* </p> */}
                  </Tag>
                </Feed.Content>
                <Feed.Label>
                  <Image
                    floated={seq.message === "response" ? "left" : "right"}
                    alt="A"
                    src={seq.image_url}
                  />
                </Feed.Label>
              </Feed.Event>
            </Feed>
          </div>
        </Animated>
      </>
    );
  };
  let messages =
    sequence &&
    sequence.map(seq =>
      seq.message === "response" ? MyMessage(seq) : TheirMessage(seq)
    );
  console.log(sequence);
  const DoDisplay = value => {
    if (value && value !== undefined && value !== "!resume") {
      return "";
    }
    return "none";
  };
  return (
    <Fragment>
      <p style={{ textAlign: "center", display: DoDisplay(value) }}>
        {errorMessage}
      </p>
      {messages}
      {/* {TheirMessage} */}
    </Fragment>
  );
};

export default Interview;
